






























































































































































































































import { Component, Vue, Emit, Prop, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { DateTime } from 'luxon'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { maskMoney, maskCPFCNPJ, maskDateTime } from '@/utils/common'

@Component

export default class ComponentModalAtualizarMultiplasNotasFiscais extends Vue {
  @Prop({ required: true, default: false }) disabled: boolean

  $refs!: {
    formRules: any,
    dateA: any,
    documentos: any,
  }

  formRules: any = {
    valid: true,
    dataRecebimentoNota: [v => !!v || 'O campo data de recebimento da nota é obrigatório.'],
    numeroNota: [v => !!v || 'O campo número da nota é obrigatório.'],
    numeroContasPagar: [],
    valorNotaFiscal: [v => !!v || 'O campo valor da nota é obrigatório.'],
  }

  loadAnexo: boolean = false
  loadDeletar: boolean = false
  loadConfirmar: boolean = false
  motivo: any[] = []
  dateText1: string = ''
  imageUrl: string = ''
  anexo: any = {}
  loadingDownloadNf: any = ''

  get loadingDeletar() {
    return this.loadDeletar
  }

  set loadingDeletar(value: boolean) {
    this.loadDeletar = value
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get getMotivo() {
    if (!Array.isArray(this.prestadorRecebimento.motivo)) {
      this.prestadorRecebimento.motivo = []
    }
    return this.prestadorRecebimento.motivo
  }

  set getMotivo(value) {
    if (!Array.isArray(this.prestadorRecebimento.motivo)) {
      this.prestadorRecebimento.motivo = []
    }
    this.prestadorRecebimento.motivo.splice(0, this.prestadorRecebimento.motivo.length, ...value)
  }

  set loadingAnexo(value: boolean) {
    this.loadAnexo = value
  }

  get loadingAnexo() {
    return this.loadAnexo
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get showModalAtualizarNotaFiscal() {
    return this.getFinanceiroStore.modal.editarNotaFiscal
  }

  get prestadorRecebimento() {
    return this.getFinanceiroStore.notaFiscalItem
  }

  get getDateText1() {
    this.dateText1 = this.formatISOToDate(this.getFinanceiroStore.notaFiscalItem.dataRecebimentoNota)
    return this.dateText1
  }

  set getDateText1(value: string | Date) {
    this.dateText1 = this.formatISOToDate(this.getFinanceiroStore.notaFiscalItem.dataRecebimentoNota)
  }

  get anexoNotaFiscal() {
    return this.anexo
  }

  set anexoNotaFiscal(value: any) {
    this.anexo = value
  }

  get isDisableConfirmar() {
    return this.getFinanceiroStore.disabledConfirmar
  }

  set isDisableConfirmar(value: boolean) {
    this.getFinanceiroStore.setDisabledConfirmar(value)
  }

  formatISOToDate(value: string | Date) {
    if (value === '' || !value) return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATE_SHORT)
  }

  clickDateTime(event) {
    if (!this.getFinanceiroStore.prestadorRecebimento.dataRecebimentoNota) {
      this.getFinanceiroStore.prestadorRecebimento.dataRecebimentoNota = moment(new Date()).format('YYYY-MM-DD')
    }

    this.$refs.dateA.open(event)
  }

  async confirmar() {
    this.loadingConfirmar = true
    const { files } = this.$refs.documentos.$refs.upload

    if (this.$refs.formRules.validate()) {
      if (!this.prestadorRecebimento.divergencia && (files.length < 1 && this.prestadorRecebimento.nomeArquivoOriginal === '')) {
        EventBus.$emit('setSnackbar', { show: true, text: 'É necessário anexar uma nota fiscal.', icon: 'warning', color: '#C62828' })
        this.loadingConfirmar = false
        return false
      }

      // Passo 1: Upload do arquivo apenas se houver um novo documento
      let notaFiscalUrl = this.prestadorRecebimento.notaFiscalUrl || ''
      if (files.length > 0) {
        const params: any = {
          documentoId: this.getFinanceiroStore.documentoId,
          prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
          formData: this.anexoNotaFiscal.formData,
        }
        const step1 = await this.getFinanceiroStore.uploadNotaFiscalUnica({ params, typeFile: 'pdf' })
        if (!step1.success) {
          EventBus.$emit('setSnackbar', { show: true, text: step1.message || 'Houve um problema ao enviar nota fiscal', icon: 'warning', color: '#C62828' })
          this.loadingConfirmar = false
          return false
        }
        notaFiscalUrl = step1.data.url
        files.splice(0, files.length)
      }

      const params: any = {
        prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
        motivo: this.getMotivo.length > 0 ? this.getMotivo : ['Nenhum'],
        divergencia: this.prestadorRecebimento.divergencia,
        notaFiscalUrl,
        numeroNota: this.prestadorRecebimento.numeroNota,
        numeroContasPagar: this.prestadorRecebimento.numeroContasPagar,
        valorNotaFiscal: this.prestadorRecebimento.valorNotaFiscal,
        comentario: this.prestadorRecebimento.comentario,
        documentoId: this.getFinanceiroStore.documentoId,
      }

      if (this.prestadorRecebimento.dataRecebimentoNota) {
        params.dataRecebimentoNota = this.prestadorRecebimento.dataRecebimentoNota
      }

      const response = await this.getFinanceiroStore.atualizarRecebimetno(params)

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal atualizada com sucesso.', icon: 'done', color: '#2E7D32' })
        this.getFinanceiroStore.atualizarAcaoPodeProvisionar(this.getFinanceiroStore.prestadorRecebimento.id)
        this.anexoNotaFiscal = {}
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema na atualização da nota fiscal.', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingConfirmar = false
    return false
  }

  async deletar() {
    this.loadingDeletar = true
    const params: any = {
      documentoId: this.prestadorRecebimento.documentoId,
      prestadorRecebimentoId: this.prestadorRecebimento.prestadorRecebimentoId,
    }
    const response = await this.getFinanceiroStore.deletarDocumento(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal deletada com sucesso.', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.setNotaFIscalItemAnexo('')
      this.isDisableConfirmar = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao deletar nota fiscal.', icon: 'warning', color: '#C62828' })
    }

    this.loadingDeletar = false
  }

  clearDate() {
    this.prestadorRecebimento.dataRecebimentoNota = ''
  }

  async inputFile(newFile, oldFile) {
    this.loadingAnexo = true

    if (!newFile || newFile.identifier) {
      return
    }

    const formData = new FormData()
    formData.append('notaFiscal', newFile.file)

    const params: any = {
      formData,
      prestadorRecebimentoId: this.getFinanceiroStore.prestadorRecebimento.id,
    }

    this.getFinanceiroStore.setNotaFIscalItemAnexo(newFile.name)
    this.anexoNotaFiscal = params
    this.isDisableConfirmar = true
    EventBus.$emit('setSnackbar', { show: true, text: 'Nota Fiscal enviada com sucesso.', icon: 'done', color: '#2E7D32' })

    this.loadingAnexo = false
  }

  async download(prestadorRecebimentoId: string) {
    const response = await this.getFinanceiroStore.download({ prestadorRecebimentoId })
    const win = window.open()
    // @ts-ignore
    win.document.body.style.margin = '0'
    // @ts-ignore
    win.document.body.style.padding = '0'
    // @ts-ignore
    const iframe = win.document.createElement('iframe')
    iframe.src = response.data
    iframe.setAttribute('frameborder', '0')
    iframe.setAttribute('allowfullscreen', '')
    // Estilo via cssText (CSSOM): a CSP herdada pela janela bloqueia atributo style inline
    iframe.style.cssText = 'border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; margin:-8px;'
    // @ts-ignore
    win.document.body.appendChild(iframe)
  }

  async downloadNF(arquivo: any) {
    this.loadingDownloadNf = arquivo.documentoId

    const response = await this.getFinanceiroStore.download({ prestadorRecebimentoId: arquivo.documentoId })
    const ext = (arquivo.nomeArquivoOriginal || '').toLowerCase().endsWith('.xml') ? 'xml' : 'pdf'
    const type = ext === 'xml' ? 'application/xml' : 'application/pdf'
    const data = response.data
    const blob = typeof data === 'string' && data.startsWith('data:')
      ? await (await fetch(data)).blob()
      : new Blob([data], { type })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = arquivo.nomeArquivoOriginal || `nota-fiscal.${ext}`
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)

    this.loadingDownloadNf = ''
  }

  async closeModal() {
    this.getFinanceiroStore.setModal({ name: 'editarNotaFiscal', value: false })
    this.getFinanceiroStore.setNotaFiscalItem({})
    this.isDisableConfirmar = false
    this.$refs.formRules.reset()
    await this.getFinanceiroStore.geRecebimentoById(this.getFinanceiroStore.prestadorRecebimento.id)
  }

  formatMoneyUtil(money: string) {
    return maskMoney(money)
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }

  maskDateTime(value: string) {
    return maskDateTime(value)
  }
}
